import {
  APP_RESIZE,
  KEY_COLLECTION,
  APP_KEYBOARD_ENABLED,
  ADVANCED_SEARCH_ENABLED,
  ADVANCED_SEARCH_VISIBLE,
  ASSET_TYPE,
  EDIT_MY_ACCOUNT_VISIBLE,
  SELECTED_CP_ACTIVITY_LOG_VALUE,
  SELECTED_FOLDER_EXPLORE,
  ADVANCED_SEARCH_VALUES_FROM_NAVBAR
} from "../constants/app-types";

export const setWidth = width => {
  return dispatch => {
    dispatch({ type: APP_RESIZE, payload: width });
  };
};

export const setKeyCollection = collection => {
  return dispatch => {
    dispatch({ type: KEY_COLLECTION, payload: collection });
  };
};

export const setkeyboardEnabled = isEnabled => {
  return dispatch => {
    dispatch({ type: APP_KEYBOARD_ENABLED, payload: isEnabled });
  };
};

export const setAdvancedSearchEnabled = isEnabled => {
  return dispatch => {
    dispatch({ type: ADVANCED_SEARCH_ENABLED, payload: isEnabled });
  };
};

export const setAdvancedSearchValuesFromNavBar = values => {
  return dispatch => {
    dispatch({ type: ADVANCED_SEARCH_VALUES_FROM_NAVBAR, payload: values });
  };
};

export const setAssetType = assetType => {
  return dispatch => {
    dispatch({ type: ASSET_TYPE, payload: assetType });
  };
};

export const setEditMyAccountVisible = isVisible => {
  return dispatch => {
    dispatch({ type: EDIT_MY_ACCOUNT_VISIBLE, payload: isVisible });
  };
};

export const setAdvancedSearchVisible = isVisible => {
  return dispatch => {
    dispatch({ type: ADVANCED_SEARCH_VISIBLE, payload: isVisible });
  };
};

export const setCpActivityLogSelectedValue = valueSelected => {
  return dispatch => {
    dispatch({ type: SELECTED_CP_ACTIVITY_LOG_VALUE, payload: valueSelected });
  };
};
export const setSelectedFolderExplore = valueSelected => {
  return dispatch => {
    dispatch({ type: SELECTED_FOLDER_EXPLORE, payload: valueSelected });
  };
};
